import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '~/hooks';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';

const UserLogoutFromDevices = () => {
  const dispatch = useAppDispatch();
  const { mobileScreen } = useBreakpoint();
  const { t, i18n } = useTranslation('app');
  const chevronIcon = i18n.language === 'ar' ? 'chevron-left' : 'chevron-right';

  return (
    <button
      type="button"
      onClick={() => dispatch(openModal('logoutFromDevicesModal'))}
      className="flex w-full items-center justify-between  border border-gray rounded-[8px] p-2x md:p-3x  text-start"
    >
      <div className="flex gap-2x items-center md:items-start">
        <span className="flex md:h-[48px] md:w-[48px] h-[40px] w-[40px] items-center justify-center rounded-full bg-gray_light_1 text-red_dark">
          <Icon name="logout" size={mobileScreen ? '16px' : '24px'} />
        </span>
        <div className="flex flex-1 flex-col gap-0.5x md:gap-x">
          <p className="text-title-5 md:text-title_4 text-black">
            {t('logoutFromAllDevices')}
          </p>
          <p className="text-caption-1 md:text-body_1 text-gray__dark_1">
            {t('logoutFromAllDevicesDescription')}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2x">
        <Icon
          name={chevronIcon}
          className="text-gray__dark_1"
          size={mobileScreen ? '16px' : '24px'}
        />
      </div>
    </button>
  );
};

export default UserLogoutFromDevices;
